{
  "timeValidationError": "La minute doit être comprise entre 00 et 59",
  "startEndTimeValidationError": "L'heure de fin doit être postérieure à l'heure de début",
  "Eq": "Égaux",
  "Gt": "Plus grand que",
  "Gte": "Supérieur ou égal à",
  "Lt": "Moins de",
  "Lte": "Inférieur ou égal à",
  "Ct": "Contient",
  "deleteRow": "Supprimer la ligne",
  "addRow": "Ajouter une nouvelle ligne",
  "addColumn": "Ajouter une colonne",
  "deleteAll": "Tout supprimer",
  "uploadData": "Charger des données",
  "deleteExisting": "Supprimer les éléments existants",
  "keepExisting": "Conserver les articles existants",
  "downloadData": "Télécharger les données",
  "schedule": {
    "day": "Journée",
    "date": "Date",
    "start": "Démarrer",
    "end": "Fin",
    "duration": "Durée (minutes)",
    "venue": "Lieu",
    "space": "L'espace",
    "type": "Tapez",
    "Discipline": "La discipline",
    "zero": "Zéro",
    "description": "Descriptif"
  },
  "toasts": {
    "edit_success": "Cellule modifiée avec succès",
    "edit_error": "Erreur lors de la modification de la cellule, pensez à actualiser les cellules",
    "insert_success": "{{ type }} ajouté avec succès",
    "insert_error": "Erreur lors de l'insertion d'une ligne, pensez à rafraîchir les cellules",
    "delete_success": "Entité de ligne supprimée avec succès",
    "delete_error": "Erreur lors de la suppression d'une ligne, pensez à actualiser les cellules",
    "refresh_cells": "Actualiser les cellules"
  },
  "dataTable": {
    "filter": {
      "equals": "Égaux",
      "greaterThan": "Plus grand que",
      "greaterThanOrEqualTo": "Supérieur ou égal à",
      "lessThan": "Moins de",
      "lessThanOrEqualTo": "Inférieur ou égal à",
      "contains": "Contient",
      "select_all": "Tout sélectionner"
    }
  },
  "type_something": "Tapez {{ name }}",
  "group": "Groupe",
  "count_column_header": "(Compter)",
  "none_group": "Aucune",
  "Export selected rows only": "Exporter uniquement les lignes sélectionnées",
  "Export all": "Tout exporter",
  "from": "À partir de",
  "to": "À"
}